import { render } from "./DartenGame.vue?vue&type=template&id=1965cbd8&scoped=true"
import script from "./DartenGame.vue?vue&type=script&lang=js"
export * from "./DartenGame.vue?vue&type=script&lang=js"

import "./DartenGame.vue?vue&type=style&index=0&id=1965cbd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1965cbd8"]])

export default __exports__